import { catalogList } from 'utils/catalogs/keys';

import { getCatalogByCatalogKey } from 'service/catalogsV2';

import { ACTIVE_STATUS_ACCOUNTS } from 'constants/globals';

import type { Client } from 'api/client/models';
import type LabelValue from 'commons/modules/label-value';

import { getDistinctValues, mapSelectedAccounts } from './Reports/utils';
import { documentOptions } from './Documentary/constants';

export const processClientesForReport = (
  rows: Client[],
  tmpLayouts: LabelValue[],
) => {
  return rows.map((row) => {
    const newAccounts =
      row.accounts.filter(
        (item) => item.cveStatus === ACTIVE_STATUS_ACCOUNTS,
      ) || [];
    const accounts = mapSelectedAccounts(
      newAccounts,
      newAccounts.map((it) => it.accountId),
    );
    const ids = getDistinctValues(accounts);
    const filtered = tmpLayouts.filter((it) => ids.includes(it.value));
    return {
      ...row,
      accounts,
      selected: false,
      brokerageHouses: filtered.map((it) => it.label),
    };
  });
};

export const processClientesForDocumentary = (rows: Client[]) => {
  return rows.map((row) => {
    const newAccounts =
      row.accounts.filter(
        (item) => item.cveStatus === ACTIVE_STATUS_ACCOUNTS,
      ) || [];
    const accounts = mapSelectedAccounts(
      newAccounts,
      newAccounts.map((it) => it.accountId),
    );

    return {
      ...row,
      accounts,
      selected: false,
      brokerageHouses: [],
      documentOptions: [...documentOptions],
    };
  });
};

export const getBrokerageHouses = async () => {
  let tmpLayouts: LabelValue[] = [];
  const { data, success } = await getCatalogByCatalogKey(
    catalogList.brokerageHouses.keyName,
  );

  if (success && data) {
    tmpLayouts = data.data.map(({ value01, code01 }: any) => ({
      label: value01,
      value: Number(code01),
    }));
  }

  return tmpLayouts;
};

export const processRewSelect = (
  rows: Client[],
  row: Client,
  newValue: boolean,
) => {
  const newTableRows = rows.map((item) => ({
    ...item,
    selected: item.clientId === row.clientId ? newValue : item.selected,
  }));

  return [...newTableRows];
};

export const processSelectedAll = (
  rows: Client[] = [],
  selectdAll: boolean,
) => {
  const newRows = rows.map((item) => ({
    ...item,
    selected: selectdAll,
  }));
  return [...newRows];
};
